import GuidedHighlighting from "./GuidedHighlighting";

export * from "./GuidedHighlighting.constants";

export default GuidedHighlighting;
